// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Components
import Icon from 'HTKit/Icon';
// Styles
import styles from '../styles.scss';

const StaticTextLabel = ({ hasHint = false, label = '', adjValue, showMoreInfo, onClick, additionalAnswerInfo }) => {
  let captionText;
  if (adjValue) {
    if (+adjValue > 0) captionText = `+$${adjValue}`;
    if (+adjValue < 0) captionText = `-$${adjValue * -1}`;
    if (typeof adjValue === 'string') captionText = adjValue;
  }

  const captionTextStyles = cn(styles.captionText, 'p2', {
    [styles.withHint]: hasHint || showMoreInfo,
  });
  const iconName = showMoreInfo ? 'info-outline' : 'helper';
  /*
    Conditionally applying align css because text longer than 24 characters wraps and the icon and price moves to the center of the container making it look weird
  */
  const flexStyles = label.length > 24 ? 'alignItemsBaseline' : 'alignItemsCenter';
  const clickableAreaStyles = Object.keys(additionalAnswerInfo).length ? '' : styles.clickableArea;

  return (
    <div className={styles.answerText}>
      <div className={cn('flex justifyContentSpaceBetween', clickableAreaStyles, flexStyles)}>
        <span className="n900">{label}</span>
        <div className="flex alignItemsCenter">
          {captionText && <span className={captionTextStyles}>&nbsp;{captionText}</span>}
          {(hasHint || showMoreInfo) && (
            <Icon
              name={iconName}
              className={styles.additionalInfoIcon}
              onClick={showMoreInfo && onClick}
              data-icon
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StaticTextLabel;

StaticTextLabel.propTypes = {
  hasHint: PropTypes.boolean,
  label: PropTypes.string.isRequired,
  adjValue: PropTypes.any,
  showMoreInfo: PropTypes.boolean,
  onClick: PropTypes.func,
  additionalAnswerInfo: PropTypes.object,
};
